export const TASK_CONTENT = {
  priorities: [
    { value: "1", label: "High" },
    { value: "2", label: "Medium" },
    { value: "3", label: "Low" },
  ],
};
